import api from "./api";

export const transferRuleService = {
  getTransferRules: () => api.get("/transfer-rules"),
  saveTransferRules: (data) => api.post("/transfer-rules/save", data),
};

